<span class="gap-container">
  <!-- Use the value of the input to determine the width of the gap. -->
  <span class="gap-space">{{ gapControl.value }}</span>

  <!-- The ion-input will take all the space the gap-space span will create. -->
  <ion-input [formControl]="gapControl" fill="solid" mode="md" />
</span>
